import { environment } from 'src/environments/environment';

export const isOctaInstance = (): boolean => {
  return environment.apiUrl.includes('octa');
};

export const isRecordatiInstance = (): boolean => {
  return environment.apiUrl.includes('recordati');
};
